export default ["", "DOUBLE", "FLOAT", "BYTE", "SHORT", "INT", "LONG", "BOOLEAN", "STRING"];


// WEBPACK FOOTER //
// ./src/core/constants/valueTypes.js